module.exports = __webpack_public_path__ + "media/img/pages/companies/georg_fischer-7c66ac9a4bf15a25ac3e55ddff249ec0.png";